import styled, { keyframes } from 'particles/themes/styled'

const blink = keyframes`
  50% {
    opacity: 0;
  }
`

export const Cursor = styled.span`
    display: inline-block;
    width: 1ch;
    color: #333;
    animation: ${blink} 1s step-start infinite;
`
